import { Routes, Route } from 'react-router-dom';
import RequireAuth from './middlewares/RequireAuth';
import IsAuth from './middlewares/IsAuth';
import AppLayout from './layouts/AppLayout';
import Home from './routes/Home';
import Login from './routes/Login/Login';
import Logout from './routes/Logout';

import Users from './routes/Users/Users';
import User from './routes/Users/User';

import Galleries from './routes/Galleries/Galleries';
import Gallery from './routes/Galleries/Gallery';

import Collages from './routes/Collages/Collages';
import Collage from './routes/Collages/Collage';
import CollageEdit from './routes/Collages/CollageEdit';

import Widgets from './routes/Widgets/Widgets';
import Widget from './routes/Widgets/Widget';

import WidgetsData from './routes/WidgetData/WidgetsData';
import WidgetData from './routes/WidgetData/WidgetData';

import Attributes from './routes/Attributes/Attributes';
import Attribute from './routes/Attributes/Attribute';

import Categories from './routes/Categories/Categories';
import Category from './routes/Categories/Category';

import Pages from './routes/Pages/Pages';
import Page from './routes/Pages/Page';

import Products from './routes/Products/Products';
import Product from './routes/Products/Product';

import Sefurls from './routes/Sefurls/Sefurls';
import Sefurl from './routes/Sefurls/Sefurl';

import Templates from './routes/Templates/Templates';
import Template from './routes/Templates/Template';

import './App.css'

function App() {
  return (
    <Routes>
      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route path="" element={<Home />} />

          <Route path="pages" element={<Pages />} />
          <Route path="page" element={<Page />} />
          <Route path="page/:id" element={<Page />} />

          <Route path="categories" element={<Categories />} />
          <Route path="category" element={<Category />} />
          <Route path="category/:id" element={<Category />} />

          <Route path="products" element={<Products />} />
          <Route path="product" element={<Product />} />
          <Route path="product/:id" element={<Product />} />

          <Route path="attributes" element={<Attributes />} />
          <Route path="attribute" element={<Attribute />} />
          <Route path="attribute/:id" element={<Attribute />} />

          <Route path="sefurls" element={<Sefurls />} />          

          <Route path="galleries" element={<Galleries />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="gallery/:id" element={<Gallery />} />

          <Route path="templates" element={<Templates />} />
          <Route path="template" element={<Template />} />
          <Route path="template/:id" element={<Template />} />
          
          <Route path="gallery/:id/collages" element={<Collages />} />
          <Route path="gallery/:id/collage" element={<Collage />} />
          <Route path="gallery/:id/collage/:id" element={<CollageEdit />} />

          <Route path="widgets" element={<Widgets />} />
          <Route path="widget" element={<Widget />} />
          <Route path="widget/:id" element={<Widget />} />

          <Route path="widget/:id/widgetsdata" element={<WidgetsData />} />
          <Route path="widget/:id_widget/widgetdata" element={<WidgetData />} />
          <Route path="widget/:id_widget/widgetdata/:id" element={<WidgetData />} />          

          <Route path="users" element={<Users />} />
          <Route path="user" element={<User />} />
          <Route path="user/:id" element={<User />} />

          <Route path="users/groups" element={<Users />} />
        </Route>
        <Route path="logout" element={<Logout />} />
      </Route>
      <Route element={<IsAuth />}>
        <Route path="login" element={<Login />} />
      </Route>
    </Routes>
  );
}

export default App;
